import { FORMAT_DD_MM_YYYY } from '../constants';
import { createDownloadableLink } from '@/helpers';
import customToast from '@/new-components/CustomNotification';
import { isEmpty } from 'lodash';
import moment from 'moment';
import { synthesize } from 'redux-dispatcher';

const mapDispatchToAC = {
  getCompanySuccess: (data) => ({ data }),
  getCompany:
    (search, paging, filterOption) =>
    async ({ Api, getState }) => {
      let pagingData = paging || getState().company.paging;
      let { result, status } = await Api.post(`companies/filter`, {
        pageIndex: pagingData.pageIndex,
        pageSize: pagingData.pageSize,
        search,
        ...filterOption,
      });
      if (status === 200) {
        const { list, ...restParams } = result;
        const baseIndex = pagingData.pageIndex * pagingData.pageSize + 1;
        const dataAddIndex = list.map((item, index) => ({
          ...item,
          index: baseIndex + index,
        }));

        companyDispatcher.getCompanySuccess({
          ...restParams,
          list: dataAddIndex,
        });
      }
    },
  getDetailedCompany:
    (companyId, callbackSuccess) =>
    async ({ Api }) => {
      const { result, status } = await Api.get(`companies/${companyId}`);
      if (status === 200) {
        callbackSuccess && callbackSuccess(result);
      }
    },
  getKeyCompany:
    () =>
    async ({ Api }) => {
      const { result, status } = await Api.get(`companies/key-values`);
      status === 200 && companyDispatcher.getCompanySuccess({ list: result });
    },
  setState: (state, value) => ({ state, value }),
  createCompany:
    (data, callback) =>
    async ({ Api }) => {
      const { status, result, message } = await Api.post('companies', data);
      companyDispatcher.setState('loading', false);
      if (status === 200) {
        callback && callback(result);
        return customToast('success', message || 'Create success');
      }
    },
  editCompany:
    (payload, callbackSuccess) =>
    async ({ Api, customToast }) => {
      const { data, id } = payload;
      const { result, status } = await Api.put(`companies/${id}`, data);
      companyDispatcher.setState('loading', false);
      if (status === 200) {
        callbackSuccess && callbackSuccess(result);
      }
    },
  deleteCompany:
    (id, callbackSuccess) =>
    async ({ Api, customToast }) => {
      const { status } = await Api.delete(`companies/${id}`);
      if (status === 200) {
        customToast('success', 'Company deleted');
        callbackSuccess && callbackSuccess();
      }
    },
  createProject:
    (data, callbackSuccess) =>
    async ({ Api, customToast }) => {
      const { status } = await Api.post(`projects`, data);
      if (status === 200) {
        callbackSuccess && callbackSuccess();
      }
    },
  editProject:
    (id, data, callbackSuccess) =>
    async ({ Api, customToast }) => {
      const { status } = await Api.put(`projects/${id}`, data);
      if (status === 200) {
        callbackSuccess && callbackSuccess();
      }
    },
  getProjectByCompanyID:
    (companyId, callbackSuccess) =>
    async ({ Api }) => {
      const { status, result } = await Api.get(`projects`, { companyId });
      if (status === 200) {
        callbackSuccess && callbackSuccess(result.list);
      }
    },
  getProjectByID:
    (id, callbackSuccess) =>
    async ({ Api, customToast }) => {
      const { result, status } = await Api.get(`projects/${id}`);
      if (status === 200) {
        callbackSuccess && callbackSuccess(result);
      }
    },
  getPackageDataSuccess: (data) => ({ data }),
  getPackageById:
    (id, callbackSuccess) =>
    async ({ Api, customToast }) => {
      const { result, status } = await Api.get(`packages/${id}`);
      if (status === 200) {
        callbackSuccess(result);
      }
    },
  deleteProject:
    (id, callbackSuccess) =>
    async ({ Api, customToast }) => {
      const { status } = await Api.delete(`projects/${id}`);
      if (status === 200) {
        customToast('success', 'Deleted');
        callbackSuccess && callbackSuccess();
      }
    },
  cloneProject:
    (id, callbackSuccess) =>
    async ({ Api, customToast }) => {
      const { status } = await Api.put(`projects/clones`, { id });
      if (status === 200) {
        customToast('success', 'Project duplicated successfully');
        callbackSuccess && callbackSuccess();
      }
    },
  getExportExcel:
    (search, paging, filterOption) =>
    async ({ Api, getState }) => {
      let pagingData = paging || getState().company.paging;
      let { result, status } = await Api.post(`companies/exports/csv`, {
        pageIndex: pagingData.pageIndex,
        pageSize: pagingData.pageSize,
        search,
        ...filterOption,
      });
      status === 200 && createDownloadableLink(result, 'companies-report');
    },
  getProjectByCode:
    (code, callbackSuccess) =>
    async ({ Api }) => {
      const { result, status } = await Api.get('projects/by-code', { code });
      if (status === 200) {
        callbackSuccess && callbackSuccess(result);
      } else {
        callbackSuccess && callbackSuccess(false);
      }
    },
  getProjectOrganization:
    (callbackSuccess) =>
    async ({ Api }) => {
      const { result, status } = await Api.get(`projects/pm-codes`);
      if (status === 200) {
        callbackSuccess && callbackSuccess(result);
      }
    },
  getProjectKeyValue:
    (callbackSuccess) =>
    async ({ Api }) => {
      const { result, status } = await Api.get(`projects/key-values`);
      if (status === 200) {
        callbackSuccess && callbackSuccess(result);
      }
    },
  getLocationKeyValue:
    (callbackSuccess) =>
    async ({ Api }) => {
      const { result, status } = await Api.get(`locations/key-values`);
      if (status === 200) {
        const newResult = result.filter((it) => !isEmpty(it.name));
        callbackSuccess && callbackSuccess(newResult);
      }
    },
  getProjectByLocation:
    (locationIds, callbackSuccess) =>
    async ({ Api }) => {
      const { status, result } = await Api.post(`projects/all-by-location`, {
        locationIds,
      });
      if (status === 200) {
        callbackSuccess && callbackSuccess(result);
      }
    },
  getExportCRReport:
    (projectId) =>
    async ({ Api }) => {
      let { result, status } = await Api.post(
        `projects/${projectId}/cr-report/compilations`
      );
      const fileName = `CR_Report_${moment().format(FORMAT_DD_MM_YYYY)}`;
      status === 200 && createDownloadableLink(result, fileName);
    },
  getDownloadSubsidyForm:
    (projectId, projectName) =>
    async ({ Api }) => {
      let { result, status } = await Api.get(`projects/subsidy-claim-form`, {
        projectId,
      });
      const fileName = `${projectName} Subsidy Claim Forms`;
      status === 200 && createDownloadableLink(result, fileName, 'zip');
    },
  getStationsByProject:
    (projectId, callbackSuccess) =>
    async ({ Api }) => {
      const { status, result } = await Api.get(
        `projects/${projectId}/station-config`
      );
      if (status === 200) {
        callbackSuccess && callbackSuccess(result);
      }
    },
  editSequencesStations:
    (projectId, items, callbackSuccess) =>
    async ({ Api }) => {
      const { status } = await Api.put(`projects/${projectId}/station-config`, {
        items,
      });
      if (status === 200) callbackSuccess && callbackSuccess();
    },
  getAllProjects:
    (callbackSuccess) =>
    async ({ Api }) => {
      const { result, status } = await Api.get(`projects`);
      if (status === 200) {
        callbackSuccess && callbackSuccess(result);
      }
    },
};

const companyDispatcher = synthesize('company', mapDispatchToAC);
export default companyDispatcher;
